import { render, staticRenderFns } from "./ChipGroup.vue?vue&type=template&id=5a6d2ef4&scoped=true"
import script from "./ChipGroup.vue?vue&type=script&lang=js"
export * from "./ChipGroup.vue?vue&type=script&lang=js"
import style0 from "./ChipGroup.vue?vue&type=style&index=0&id=5a6d2ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6d2ef4",
  null
  
)

export default component.exports